import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { HTMLProps } from 'react';
import { Color } from '@diritto/common/style/color';
import { CheckBoxIcon } from 'icons/CheckBoxIcon';

interface CheckBoxProps extends HTMLProps<HTMLInputElement> {
  id?: string;
  children: React.ReactNode;
  className?: string;
}

export const CheckBox = ({ id, className, checked, onChange, children }: CheckBoxProps) => (
  <CheckBoxWrapper>
    <StyledCheckBoxIcon checked={checked} />
    <StyledButton id={id} className={className} type="checkbox" checked={checked} onChange={onChange} />
    <StyledBodyWrapper>{children}</StyledBodyWrapper>
  </CheckBoxWrapper>
);

const CheckBoxWrapper = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledCheckBoxIcon = styled(CheckBoxIcon)(
  ({ checked }: { checked?: boolean }) => css`
    border: 1px solid ${checked ? 'transparent' : Color.Gray400};
    border-radius: 3px;
    margin-right: 8px;
  `,
);

const StyledButton = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const StyledBodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
